import React, { useState } from 'react';
import TuneRoundedIcon from '@material-ui/icons/TuneRounded';
import defaultLocales from 'globals/locales/default';
import FsFlagsModal from 'ui-elements/modals/FsFlagsModal';
import { StyledIconButton } from './FsFlagsButton.style-elements';

const FsFlagsButton: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <StyledIconButton onClick={() => setShowModal(true)}>
        <TuneRoundedIcon />
      </StyledIconButton>
      <FsFlagsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={defaultLocales.settingsFlags}
        fullWidth
        maxWidth="sm"
      />
    </>
  );
};

export default FsFlagsButton;
